import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import BaseGrid from '../grid/BaseGrid';
import { fetchResourceFileDetails } from './resources-action';
import { getLoadingFile, getResourcesFile } from './resources-reducer';

export const ResourceDetails = ({ visible, tableId, onCancel }) => {
  const resourceFileData = useSelector(getResourcesFile);
  const loading = useSelector(getLoadingFile);

  return (
    <StyledValidationModal
      visible={visible}
      style={{ display: 'flex', justifyContent: 'center' }}
      className='modal-wrap'
      onCancel={onCancel}
      footer={<></>}
    >
      <BaseGrid
        id={tableId}
        total={resourceFileData.length}
        search={''}
        loading={loading}
        isPagination={true}
        onlyTotalCount={true}
        setSearch={''}
      />
    </StyledValidationModal>
  );
};

const StyledValidationModal = styled(Modal)`
  .ant-modal-content {
    width: 250%;
  }
`;

const StyledTitle = styled.div`
  width: 100%;
  text-align: center;
`;
